import { IOutlet } from '@cakeiteasy/web-utils';

export const OUTLET_ACTION_MESSAGE_KEYS = {
  CART_RESTRICTION: 'orderProcess.delivery.chooseOutlet.outletUnavailableDueToCart',
  DISPLAY_ONLY: 'orderProcess.delivery.chooseOutlet.outletDisplayOnly'
};

export interface IOutletActionState {
  hideNextButton: boolean;
  messageKey: string;
}

interface IOutletActionStateParams {
  outlet: IOutlet;
  disabledOutletIds?: number[];
  isOutletSelectionStateEnabled?: boolean;
}

export const getOutletActionState = (
  { outlet, disabledOutletIds = [], isOutletSelectionStateEnabled = true }: IOutletActionStateParams
): IOutletActionState => {

  const defaultValue = {
    hideNextButton: false,
    messageKey: ''
  };

  if (!isOutletSelectionStateEnabled) {
    return defaultValue;
  }

  if (outlet.isDisplayOnly) {
    return {
      hideNextButton: true,
      messageKey: OUTLET_ACTION_MESSAGE_KEYS.DISPLAY_ONLY
    };
  }

  if (disabledOutletIds.indexOf(outlet.id) >= 0) {
    return {
      hideNextButton: true,
      messageKey: OUTLET_ACTION_MESSAGE_KEYS.CART_RESTRICTION
    };
  }

  return defaultValue;
};
